import React, { useState } from 'react';
import Calling from '../../../components/Calling';
import Timer from '../../../components/Timer';
import PopupBox from '../../../components/PopupBox';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { useAuth } from '../../../provider/AuthProvider';
// import ringer from "../../../files/voice1.mp3";
const Calll = () => {
  const [answer, setAnswer] = useState(false);
  const [show, setShow] = useState(false);
  const audio = new Audio('/files/voice1.mp3');
  const {token}=useAuth()
  audio.loop = false;
  audio.onended=(e)=>{
   
    navigate('../one/contacts');
  }
  const navigate = useNavigate();

  var totalSeconds=0;
  const [minutesLabel, setMinutesLabel] = useState(0);
  const [secondsLabel, setSecondsLabel] = useState(0);
  const [, forceUpdate] = useState(0);
  var vibInterval = setInterval(() => {
    try {
      if (answer === true) return;
      if ('vibrate' in navigator) {
        let vibration = 220;
        navigator.vibrate(vibration);

        navigator.vibrate([
          100, 30, 100, 30, 100, 30, 200, 30, 200, 30, 200, 30, 100, 30, 100,
          30, 100,
        ]);
      }
    } catch (e) {}
  }, 4000);

  useEffect(() => {
    return () => {
      clearInterval(vibInterval);
    };
  });
  const callAnwser = () => {
    if (!answer) {
      setAnswer(true);
      audio.play();
    }
  };
  const pad = (val) => {
    var valString = val + '';
    if (valString.length < 2) {
      return '0' + valString;
    } else {
      return valString;
    }
  };
  const setTime = () => {
    totalSeconds+=1;
    setSecondsLabel(pad(totalSeconds % 60));
    setMinutesLabel(pad(parseInt(totalSeconds / 60)));
  };
  useEffect(() => {
    if (answer == 1) var timeInterval = setInterval(setTime, 1000);
    else clearInterval(timeInterval)

    return () => {
      clearInterval(timeInterval)
    };
  }, [answer]);

  useEffect(() => {
 
    if(!(token.status>=1.1))
      navigate("/one",{replace:true})
    return () => {
     audio.pause();
      };
  },[])
  return (
    <div className="call bg-white  p-5  text-center ">
      <img src="/images/frame.png" alt="" id='frame' />
      <div className="label">
        <h2>Unknown</h2>
        {answer ? (
          <div style={{ position: 'relative', zIndex: 99 }} >
           <label className="text-white">{secondsLabel}</label>
            <label className="text-white">:</label>
            <label className="text-white">{minutesLabel}</label>
          
          </div>
        ) : (
          <p>calling...</p>
        )}
      </div>
      <div
        className={`call-options mb-3 d-grid align-items-end ${
          !answer ? 'opacity-0' : 'opacity-100'
        }`}
      >
        <div className="row align-items-baseline ">
          <div
            className="col-4 justify-content-center overflow-hidden"
            onClick={() => setShow(true)}
          >
            <img src="/icons/speaker.svg"  className='w-100'/>
            <sub className="mt-3">Speaker</sub>
          </div>
          <div
            className="col-4  justify-content-center overflow-hidden"
            onClick={() => setShow(true)}
          >
            <img src="/icons/keypad.svg" className='w-100' />
            <sub className="mt-3">Keypad</sub>
          </div>
          <div
            className="col-4  justify-content-center overflow-hidden"
            onClick={() => setShow(true)}
          >
            <img src="/icons/mute.svg"  className='w-100'/>
            <sub className="mt-3">Mute</sub>
          </div>
        </div>
        <div className="row align-items-baseline">
          <div
            className="col-4  justify-content-center overflow-hidden"
            onClick={() => setShow(true)}
          >
            <img src="/icons/contacts.svg"  className='w-100'/>
            <sub className="mt-3 flex-nowrap text-nowrap text-center justify-items-center text-center m-auto">
              Contacts
            </sub>
          </div>
          <div
            className="col-4 justify-content-center overflow-hidden"
            onClick={() => setShow(true)}
          >
            <img src="/icons/facetime.svg" className='w-100'/>
            <sub className="mt-3">FaceTime</sub>
          </div>
          <div
            className="col-4  justify-content-center overflow-hidden"
            onClick={() => setShow(true)}
          >
            <img src="/icons/addcall.svg" className='w-100'/>
            <sub className="mt-3">Add Call</sub>
          </div>
        </div>
      </div>
      <div className={`answer  ${answer ? 'opacity-0' : 'opacity-100'}`}>
        <div className="d-flex align-items-center ps-3 pe-0 justify-content-between">
          <sub>Message</sub>
          <sub>Remind Me</sub>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="calling">
            <div
              className="button"
              role="button"
              onClick={() => {
                callAnwser();
              }}
            >
              <a href="#" className="email-text">
                <img src="/icons/answer.svg" alt="" />
              </a>
            </div>
          </div>

          <div className="decline">
            <div className="button-decline">
              <img src="/icons/reject.svg" alt="" />
            </div>
          </div>
        </div>
        <div className="buttons-label pe-3 ps-3">
          <sub>accept </sub>
          <sub>decline</sub>
        </div>
      </div>
      <PopupBox setShow={setShow} show={show} text="این گزینه غیر فعال است" />
    </div>
  );
};
export default Calll;
